export enum LotStatus {
  AVAILABLE_FOR_SALE = 'available_for_sale',
  RESERVED = 'reserved',
  SOLD = 'sold',
  UNAVAILABLE = 'unavailable',
}

export enum LotType {
  CREMATION_PLOT = 'cremation_plot',
  CRYPT = 'crypt',
  GREEN_BURIAL = 'green_burial',
  INFANT = 'infant',
  NICHE = 'niche',
  OSSUARY = 'ossuary',
  PLOT = 'plot',
}

export const LotTypeShown = {
  [LotType.CREMATION_PLOT]: 'Cremation Plot',
  [LotType.CRYPT]: 'Crypt',
  [LotType.NICHE]: 'Niche',
  [LotType.PLOT]: 'Plot',
  [LotType.GREEN_BURIAL]: 'Green Burial',
  [LotType.OSSUARY]: 'Ossuary',
  [LotType.INFANT]: 'Infant',
};

export const ORDERED_LOT_LIST = [
  LotType.PLOT,
  LotType.CREMATION_PLOT,
  LotType.NICHE,
  LotType.CRYPT,
  LotType.GREEN_BURIAL,
  LotType.OSSUARY,
  LotType.INFANT,
];

export const TYPE_OF_LOTS = window.TYPE_OF_LOTS || [];
export const AVAILABLE_LOT_TYPES = ORDERED_LOT_LIST.filter((type) => TYPE_OF_LOTS.includes(type));
export const DEFAULT_LOT_TYPE = AVAILABLE_LOT_TYPES.length === 1 ? AVAILABLE_LOT_TYPES[0] : null;
